<template>
  <div>
    <UmDbBoardList :boards="boards" stickyHeader="80vh" />
  </div>
</template>

<script type="text/javascript">
import UmDbBoardList from "@/components/UmDb/UmDbBoardList";

export default {
  name: "UmDbBoardListView",
  metaInfo: {
    title: "Boards | UmDb",
  },
  components: { UmDbBoardList },
  data() {
    return {};
  },
  computed: {
    boards() {
      return this.$store.state.umDbBoardList;
    },
  },
};
</script>
